import { useState, useEffect, PropsWithChildren } from 'react';
import Header from './Header';
import styles from './layOut.module.scss';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';
import { ROOT_PATH } from '@utils/constants/Routes';

const LayOut = ({ children }: PropsWithChildren) => {
    const { pathname } = useLocation();
    const [hasLinkToMainPage, setHasLinkToMainPage] = useState<boolean>(false);

    useEffect(() => {
        setHasLinkToMainPage(pathname !== ROOT_PATH);
    }, [pathname]);

    return (
        <>
            <div>
                <Header hasLinkToMainPage={hasLinkToMainPage} />
                <div className={styles['layout']}>{children}</div>
            </div>
            <Footer />
        </>
    );
};

export default LayOut;
